import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../pages/login/UserContextPersistent";
import {
  installAuthSessionWatchers,
  installAxiosAuthInterceptor,
  uninstallAxiosAuthInterceptor,
} from "./axiosAuthInterceptor";
import { setupPushNotificationListeners } from "../utils/pushNotifications";

export default function AxiosAuthBootstrap() {
  const navigate = useNavigate();
  const { dispatch } = useUser();
  const dispatchRef = useRef(dispatch);
  const navigateRef = useRef(navigate);

  dispatchRef.current = dispatch;
  navigateRef.current = navigate;

  useEffect(() => {
    installAxiosAuthInterceptor(
      () => dispatchRef.current,
      () => navigateRef.current,
    );
    setupPushNotificationListeners();
    const removeSessionWatchers = installAuthSessionWatchers();
    return () => {
      removeSessionWatchers();
      uninstallAxiosAuthInterceptor();
    };
  }, []);

  return null;
}
